exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1oG5t{font-size:1.5em;padding:8px 0 6px;display:inline-block;color:#6eb658;text-decoration:none}@media screen and (min-width:768px){._1oG5t{font-size:2em;padding:0}}._2Vdwf{font-weight:700;text-transform:uppercase}._25Cpu{font-size:1.5em;color:#fff}", ""]);

// exports
exports.locals = {
	"brand": "_1oG5t",
	"brandTxt": "_2Vdwf",
	"inverse": "_25Cpu"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":{"discardComments":{"removeAll":true}}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Brand/Brand.css
// module id = 541
// module chunks = 0 1 2 3 4